












import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
  name: "v-card"
})
export default class VCard extends Vue {
  @Prop()
  title!: string;
}
